export default [
  {
    create_one: "Opret",
    keep_me: "Forbliv logget ind",
    no_account: "Har du ikke en konto endnu?",
    subtitle: "Indtast dine kontooplysninger nedenfor",
    title: "Velkommen tilbage",
  },
];
